<div class="orders-partial-log">
	<ag-grid-angular
		#grid class="ag-theme-balham grid-logs"
		[enableCellTextSelection]="true"
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="false"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'autoHeight'"
		[rowClassRules]="rowClassRules"
		[rowData]="gridData"
		(selectionChanged)="onSelectionChanged()"
	>
	</ag-grid-angular>
</div>
